module.exports = __webpack_public_path__ + "/images/logo-af-c-and-a.06ed410.webp";